import { z } from 'zod';

/**
 * Priority enum shared by `Card` and `Task`. Spec v4 widens this from the
 * old two-value (`normal | urgente`) shape to a four-value scale used to
 * sort the task board and badge the conversation board.
 */
export const PrioritySchema = z.enum(['low', 'normal', 'high', 'urgent']);

export type Priority = z.infer<typeof PrioritySchema>;

/** Urgency rank, ascending: `low` (0) → `urgent` (3). */
const PRIORITY_RANK: Record<Priority, number> = {
  low: 0,
  normal: 1,
  high: 2,
  urgent: 3,
};

/** Returns the more urgent of two priorities (ties return `a`). */
export function maxPriority(a: Priority, b: Priority): Priority {
  return PRIORITY_RANK[a] >= PRIORITY_RANK[b] ? a : b;
}
